import counsellorHttpCommon from "../helper/counsellorHttpCommon";

export const counsellorLogin = (credentials) => {
  return counsellorHttpCommon.post("counsellor-portal/login/", credentials, {
    skipAuth: true,
  });
};

export const counsellorGoogleLogin = (payload) => {
  return counsellorHttpCommon.post("counsellor-portal/google/", payload, {
    skipAuth: true,
  });
};

export const fetchCounsellorPortalMe = () => {
  return counsellorHttpCommon.get("counsellor-portal/me/");
};

export const fetchCounsellorPortalDashboard = ({ timezone = "" } = {}) => {
  const params = {};
  if (timezone) params.timezone = timezone;

  return counsellorHttpCommon.get("counsellor-portal/dashboard/", {
    params,
  });
};

export const fetchCounsellorPortalProfile = () => {
  return counsellorHttpCommon.get("counsellor-portal/profile/");
};

export const updateCounsellorPortalProfile = (formData) => {
  return counsellorHttpCommon.patch("counsellor-portal/profile/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const fetchCounsellorPortalBookings = ({
  page = 1,
  pageSize = 20,
  status = "",
  search = "",
  month = "",
} = {}) => {
  const params = {
    page,
    page_size: pageSize,
  };

  if (status) params.status = status;
  if (search) params.search = search;
  if (month) params.month = month;

  return counsellorHttpCommon.get("counsellor-portal/bookings/", { params });
};

export const fetchCounsellorPortalDashboardBookings = ({
  page = 1,
  pageSize = 10,
  search = "",
  status = "",
  period = "",
  timezone = "",
} = {}) => {
  const params = {
    page,
    page_size: pageSize,
  };

  if (search) params.search = search;
  if (status) params.status = status;
  if (period) params.period = period;
  if (timezone) params.timezone = timezone;

  return counsellorHttpCommon.get("counsellor-portal/dashboard/bookings/", {
    params,
  });
};

export const fetchCounsellorPortalCalendarSlots = ({
  startDate = "",
  days = 7,
  timezone = "",
} = {}) => {
  const params = { days };
  if (startDate) params.start_date = startDate;
  if (timezone) params.timezone = timezone;

  return counsellorHttpCommon.get("counsellor-portal/calendar/slots/", {
    params,
  });
};

export const publishCounsellorPortalCalendarSlots = ({
  slots = [],
  startDate = "",
  days = 7,
  timezone = "",
  replaceExisting = true,
} = {}) => {
  const payload = {
    days,
    replace_existing: replaceExisting,
    slots: slots.map((slot) => ({
      date: slot.date,
      start_time: slot.start_time,
      end_time: slot.end_time,
    })),
  };
  if (startDate) payload.start_date = startDate;
  if (timezone) payload.timezone = timezone;

  return counsellorHttpCommon.post(
    "counsellor-portal/calendar/slots/publish/",
    payload,
  );
};

export const unpublishCounsellorPortalCalendarSlots = ({
  slots = [],
  startDate = "",
  days = 7,
  timezone = "",
} = {}) => {
  const payload = {
    days,
    slots: slots.map((slot) => ({
      date: slot.date,
      start_time: slot.start_time,
      end_time: slot.end_time,
    })),
  };
  if (startDate) payload.start_date = startDate;
  if (timezone) payload.timezone = timezone;

  return counsellorHttpCommon.post(
    "counsellor-portal/calendar/slots/unpublish/",
    payload,
  );
};
